import { useEffect, useState } from 'react';

import {
  MEDIUM_BREAKPOINT,
  SCREEN_BREAKPOINT_NAMES,
  SMALL_BREAKPOINT,
} from '@/components/modular-grid/constants';
import { debounce } from '@/utils/lodash-alternatives';

export const useWindowBreakpoint = () => {
  const getBreakpointForScreenSize = () => {
    if (window.innerWidth <= SMALL_BREAKPOINT.max)
      return SCREEN_BREAKPOINT_NAMES.small;
    else if (window.innerWidth <= MEDIUM_BREAKPOINT.max)
      return SCREEN_BREAKPOINT_NAMES.medium;
    else return SCREEN_BREAKPOINT_NAMES.large;
  };

  const [breakpoint, setBreakpoint] = useState<SCREEN_BREAKPOINT_NAMES>(
    getBreakpointForScreenSize()
  );

  useEffect(() => {
    const handleResize = debounce(() => {
      setBreakpoint(getBreakpointForScreenSize());
    }, 500);

    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return { breakpoint };
};
